const form = {
  formId: "new-user-form",
  formField: {
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    period: {
      name: "period",
      label: "[04] Kỳ: Cổ tức, lợi nhuận được chia của năm",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ",
    },
    profits: {
      name: "profits",
      label: "[06] Lợi nhuận được chia",
      type: "boolean",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn lợi nhuận",
    },
    dividends: {
      name: "dividends",
      label: "[05] Cổ tức được chia",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập cổ t",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[07] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    resolutions: {
      name: "resolutions",
      label: "Nghị quyết/ Quyết định số",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Nghị quyết/ Quyết định số",
    },
    taxId: {
      name: "taxId",
      label: "[08] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxId2: {
      name: "taxId2",
      label: "[10] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label:
        "[09] Tên đơn vị phụ thuộc/địa điểm kinh doanh của hoạt động sản xất kinh doanh khác tỉnh nơi đóng trụ sở chính",
      type: "text",
      placeholder: "",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[09] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    date: {
      name: "date",
      label: "[01] Ngày được nhận cổ tức, lợi nhuận:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Ngày",
      invalidMsg: "Ngày không hợp lệ",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[11] Hợp đồng đại lý thuế/số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn hợp đồng đại lý thuế/số",
    },
  },
};

export default form;
